import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'reactstrap';
import { connect } from 'react-redux';
import { deleteService } from './actions';
import { getServices } from './reducer';
import { hasMutation } from './utils';

class ServiceList extends Component {
  deleteService = id => {
    this.props.deleteService(id, 'cs');
  };

  renderTable = () => {
    const { services } = this.props;

    return services.map((item, index) => {
      const hasCs = hasMutation(item, 'cs');
      const hasEn = hasMutation(item, 'en');
      return (
        <tr key={index}>
          <td>{hasCs ? item.header.cs : hasEn ? item.header.en : ''}</td>
          <td>
            <Link
              to={{
                pathname: hasCs ? `/sluzby/edit/${item.id}/cs` : `/sluzby/new`,
                state: { id: item.id, lang: 'cs', disableSelect: true }
              }}
            >
              {hasCs ? 'Upravit cs' : 'Vytvořit cs'}
            </Link>
          </td>
          <td>
            <Link
              to={{
                pathname: hasEn ? `/sluzby/edit/${item.id}/en` : `/sluzby/new`,
                state: { id: item.id, lang: 'en', disableSelect: true }
              }}
            >
              {hasEn ? 'Upravit en' : 'Vytvořit en'}
            </Link>
          </td>
          <td>{item.updated}</td>
        </tr>
      );
    });
  };

  render() {
    const { services } = this.props;

    if (services.length === 0) {
      return <div>Seznam služeb je prázdný</div>;
    }

    return (
      <Table>
        <thead>
          <tr>
            <th>Název</th>
            <th>Cs</th>
            <th>En</th>
            <th>Naposledy upraveno</th>
          </tr>
        </thead>
        <tbody>{this.renderTable()}</tbody>
      </Table>
    );
  }
}

const mapStateToProps = state => {
  return {
    services: getServices(state)
  };
};

export default connect(
  mapStateToProps,
  { deleteService }
)(ServiceList);



// WEBPACK FOOTER //
// ./src/modules/ServiceList/index.js